import React from 'react';
import '../static/NewDashboard.scss';
//NewDashboard
 
const Dashboard = () => {
  return (
    <>
      
      
        <div className="responsive-wrapper">
          <div className="main-header">
            <h1>Settings</h1>
            <div className="search">
              <input type="text" placeholder="Search" />
              <button type="submit">
                <i className="ph-magnifying-glass-bold"></i>
              </button>
            </div>
          </div>

          <div className="horizontal-tabs">
            {["My details", "Profile", "Password", "Team", "Plan", "Billing", "Email", "Notifications", "Integrations", "API"].map(tab => (
              <a href="#" className={tab === "Integrations" ? "active" : ""} key={tab}>{tab}</a>
            ))}
          </div>

          <div className="content-header">
            <div className="content-header-intro">
              <h2>Intergrations and connected apps</h2>
              <p>Supercharge your workflow and connect the tool you use every day.</p>
            </div>
            <div className="content-header-actions">
              <a href="#" className="button">
                <i className="ph-faders-bold"></i>
                <span>Filters</span>
              </a>
              <a href="#" className="button">
                <i className="ph-plus-bold"></i>
                <span>Request integration</span>
              </a>
            </div>
          </div>

          <div className="content">
            <div className="content-panel">
              <div className="vertical-tabs">
                {["View all", "Developer tools", "Communication", "Productivity", "Browser tools", "Marketplace"].map(tab => (
                  <a href="#" className={tab === "View all" ? "active" : ""} key={tab}>{tab}</a>
                ))}
              </div>
            </div>
            <div className="content-main">
              <div className="card-grid">
                {[
                  { name: "Zeplin", description: "Collaboration between designers and developers.", img: "zeplin.svg", checked: true },
                  { name: "GitHub", description: "Link pull requests and automate workflows.", img: "github.svg", checked: true },
                  { name: "Figma", description: "Embed file previews in projects.", img: "figma.svg", checked: true },
                  { name: "Zapier", description: "Build custom automations and integrations with apps.", img: "zapier.svg", checked: false },
                  { name: "Notion", description: "Embed notion pages and notes in projects.", img: "notion.svg", checked: true },
                  { name: "Slack", description: "Send notifications to channels and create projects.", img: "slack.svg", checked: true },
                  { name: "Zendesk", description: "Link and automate Zendesk tickets.", img: "zendesk.svg", checked: true },
                  { name: "Atlassian JIRA", description: "Plan, track, and release great software.", img: "jira.svg", checked: false },
                  { name: "Dropbox", description: "Everything you need for work, all in one place.", img: "dropbox.svg", checked: true },
                  { name: "Google Chrome", description: "Link your Google account to share bookmarks across your entire team.", img: "google-chrome.svg", checked: true },
                  { name: "Discord", description: "Voice and chat app for teams.", img: "discord.svg", checked: true }
                ].map(({ name, description, img, checked }) => (
                  <article className="card" key={name}>
                    <div className="card-header">
                      <div>
                        <span><img src={`https://assets.codepen.io/285131/${img}`} alt={name} /></span>
                        <h3>{name}</h3>
                      </div>
                      <label className="toggle">
                        <input type="checkbox" defaultChecked={checked} />
                        <span></span>
                      </label>
                    </div>
                    <div className="card-body">
                      <p>{description}</p>
                    </div>
                    <div className="card-footer">
                      <a href="#">View integration</a>
                    </div>
                  </article>
                ))}
              </div>
            </div>
          </div>
        </div>
      
    </>
  );
};

export default Dashboard;

